import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody } from "reactstrap"

const ConfirmSendOrderModal = ({ isOpen, toggle, onSendNow, onSendWithin24Hrs }) => {
  return (
    <Modal 
      isOpen={isOpen} 
      toggle={toggle} 
      centered
      style={{ 
        borderRadius: "12px",
        maxWidth: "650px", // กำหนดความกว้างสูงสุดของ Modal
        width: "100%"
      }}
    >
      <ModalBody 
        className="py-4"
        style={{ 
          borderRadius: "12px",
          paddingLeft: "24px",
          paddingRight: "24px"
        }}
      >
        <h5 
          className="mb-3"
          style={{ 
            fontSize: "18px", 
            fontWeight: "600", 
            color: "#000",
            marginBottom: "12px"
          }}
        >
          Confirm and Send Order
        </h5>
        <p 
          className="mb-4"
          style={{ 
            fontSize: "14px", 
            color: "#6c757d",
            marginBottom: "20px"
          }}
        >
          Please choose how you would like to submit your order.
        </p>
        
        <div 
          className="d-flex"
          style={{
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center"
          }}
        >
          <button
            type="button"
            className="btn"
            style={{
              backgroundColor: "#fff",
              border: "1px solid #6c757d",
              color: "#6c757d",
              borderRadius: "8px",
              minWidth: "100px",
              padding: "8px 16px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              flexShrink: 0
            }}
            onClick={toggle}
          >
            <i className="bx bx-x" style={{ fontSize: "18px" }}></i>
            Cancel
          </button>
          
          <div 
            className="d-flex"
            style={{
              gap: "12px",
              alignItems: "center"
            }}
          >
            <button
              type="button"
              className="btn"
              style={{
                backgroundColor: "#fff",
                border: "1px solid #34c38f",
                color: "#34c38f",
                borderRadius: "8px",
                minWidth: "120px",
                padding: "8px 16px",
                flexShrink: 0
              }}
              onClick={onSendNow}
            >
              Send it Now
            </button>
            <button
              type="button"
              className="btn"
              style={{
                backgroundColor: "#34c38f",
                border: "1px solid #34c38f",
                color: "#fff",
                borderRadius: "8px",
                minWidth: "150px",
                padding: "8px 16px",
                flexShrink: 0
              }}
              onClick={onSendWithin24Hrs}
            >
              Send order within 24 hrs
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

ConfirmSendOrderModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onSendNow: PropTypes.func.isRequired,
  onSendWithin24Hrs: PropTypes.func.isRequired,
}

export default ConfirmSendOrderModal
